import React, { useState } from 'react';
import BASE_URL, { SERVER_URL } from '../config/baseUrl';

const TestAPI = () => {
  const [result, setResult] = useState('');
  const [loading, setLoading] = useState(false);

  const testHealth = async () => {
    setLoading(true);
    setResult('Testing...');
    try {
      const response = await fetch(`${SERVER_URL}/api/health`);
      const data = await response.json();
      setResult(JSON.stringify(data, null, 2));
    } catch (error) {
      setResult(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testLogin = async () => {
    setLoading(true);
    setResult('Testing login...');
    try {
      const response = await fetch(`${BASE_URL}/auth/login`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          email: 'test@example.com',
          password: 'test123'
        })
      });
      const data = await response.json();
      setResult(`Status: ${response.status}\n${JSON.stringify(data, null, 2)}`);
    } catch (error) {
      setResult(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  const testRegister = async () => {
    setLoading(true);
    setResult('Testing register...');
    try {
      const response = await fetch(`${BASE_URL}/auth/register`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          username: 'testuser',
          email: 'test@example.com',
          password: 'test123'
        })
      });
      const data = await response.json();
      setResult(`Status: ${response.status}\n${JSON.stringify(data, null, 2)}`);
    } catch (error) {
      setResult(`Error: ${error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: '20px', maxWidth: '800px', margin: '0 auto' }}>
      <h1>API Connection Test</h1>
      
      <div style={{ marginBottom: '20px', padding: '10px', background: '#f5f5f5', borderRadius: '5px' }}>
        <p><strong>Base URL:</strong> {BASE_URL}</p>
        <p><strong>Server URL:</strong> {SERVER_URL}</p>
      </div>

      <div style={{ display: 'flex', gap: '10px', marginBottom: '20px' }}>
        <button 
          onClick={testHealth} 
          disabled={loading}
          style={{ padding: '10px 20px', cursor: 'pointer' }}
        >
          Test Health Endpoint
        </button>
        <button 
          onClick={testLogin} 
          disabled={loading}
          style={{ padding: '10px 20px', cursor: 'pointer' }}
        >
          Test Login
        </button>
        <button 
          onClick={testRegister} 
          disabled={loading}
          style={{ padding: '10px 20px', cursor: 'pointer' }}
        >
          Test Register
        </button>
      </div>

      <div style={{ 
        padding: '15px', 
        background: '#000', 
        color: '#0f0', 
        borderRadius: '5px',
        fontFamily: 'monospace',
        whiteSpace: 'pre-wrap',
        minHeight: '200px'
      }}>
        {result || 'Click a button to test the API connection...'}
      </div>

      <div style={{ marginTop: '20px', padding: '15px', background: '#fff3cd', borderRadius: '5px' }}>
        <h3>Troubleshooting Steps:</h3>
        <ol>
          <li>Check if the backend server is running at https://api.bhojpurivideos.com</li>
          <li>Verify SSL certificate is valid</li>
          <li>Check CORS configuration on the backend</li>
          <li>Open browser console (F12) to see detailed error messages</li>
          <li>Verify the backend is accessible from your network</li>
        </ol>
      </div>
    </div>
  );
};

export default TestAPI;
